// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1896k","selected":"Chip_selected__3_GR7"};